import { trackingControlUI } from '../../utils';
import { classes, config } from './Constants';

export default class ControlVideo {
  constructor(el, $btnControl, $btnControlSound) {
    this.classes = classes;
    this.config = config;
    this.$el = $(el);
    this.dom = {
      $swiperBanner: this.$el.find(`.${this.classes.swiperBanner}`),
      $bannerItem: this.$el.find(`.${this.classes.swiperBanner} .${this.classes.bannerItem}`),
      $btnControls: $btnControl,
      $btnControlSounds: $btnControlSound,
      $swiperActive: `.${this.classes.bannerItem}.swiper-slide-active`,
    };
  }

  addListener() {
    this.dom.$btnControlSounds.on('click', this.SoundVideo.bind(this));
    this.dom.$btnControls.on('click', this.PlayPauseVideo.bind(this));
  }

  SoundVideo(e) {
    const $ele = $(e.currentTarget);
    $ele.addClass('mouse');
    const $parent = this.$el.find(this.dom.$swiperActive);
    const index = $parent.find(`.${this.classes.bannerBgVideo}`).attr(this.config.dataPlayer);
    if ($parent.hasClass(this.classes.bgVideo)) {
      if (!$ele.hasClass(this.classes.activeSound)) {
        this.handleVol(Number(index) - 1, false);
        $ele.addClass(this.classes.activeSound);
        $parent.addClass(this.classes.activeSound);
        $ele.attr('aria-label', ' Turn off the video sound');
        window.mutedVideo = true;
        trackingControlUI($ele, 'unmute video');
      } else {
        window.mutedVideo = false;
        this.handleVol(Number(index) - 1, true);
        $ele.removeClass(this.classes.activeSound);
        $parent.removeClass(this.classes.activeSound);
        trackingControlUI($ele, 'mute video');
      }
    }
  }

  PlayPauseVideo(e) {
    const $ele = $(e.currentTarget);
    $ele.addClass('mouse');
    $ele.addClass('pointer-events-none');
    const $parent = this.$el.find(this.dom.$swiperActive);
    const index = $parent.find(`.${this.classes.bannerBgVideo}`).attr(this.config.dataPlayer);
    if ($parent.hasClass(this.classes.bgVideo)) {
      if (!$parent.hasClass(this.classes.pauseVideo)) {
        this.handlePausePlayVideo(Number(index) - 1, true);
        $ele.addClass(this.classes.pause);
        /* eslint-disable-next-line */
        $ele.find(`.${this.classes.textControl}`).text(typeof videoPlayTextHome === null ? '' : videoPlayTextHome);
        $parent.addClass(this.classes.pauseVideo);
        trackingControlUI($ele, 'pause video');
      } else {
        this.handlePausePlayVideo(Number(index) - 1, false);
        /* eslint-disable-next-line */
        $ele.find(`.${this.classes.textControl}`).text(typeof videoPauseTextHome === null ? '' : videoPauseTextHome);
        $parent.removeClass(this.classes.pauseVideo);
        $ele.removeClass(this.classes.pause);
        trackingControlUI($ele, 'play video');
      }
    }
    setTimeout(() => {
      $ele.removeClass('pointer-events-none');
    }, 500);
  }

  handleVol(nb, isMute) {
    if (window.listVideo[nb].M !== this.config.isPlayer) {
      if (isMute) {
        this.handleMute(nb);
      } else {
        this.handleUnMute(nb);
      }
    }
  }

  handlePausePlayVideo(nb, isPause) {
    const $item = this.dom.$bannerItem;
    $item.removeClass(this.classes.openVideo);
    this.$el.find(`.${this.classes.bannerItem}[data-number="${nb}"]`).addClass(this.classes.openVideo);
    if (window.listVideo[nb].M !== this.config.isPlayer) {
      if (isPause) {
        this.handlePause(nb);
      } else {
        this.handlePlay(nb);
      }
    }
  }
  /* eslint-disable */
  handleMute(nb) {
     // youtube
    if (window.listVideo[nb] && typeof window.listVideo[nb].mute !== this.config.undefined) {
      window.listVideo[nb].mute();
    }

    // vimeo
    if (window.listVideo[nb] && typeof window.listVideo[nb].setVolume === this.config.handleFunction) {
      window.listVideo[nb].setVolume(0);
    }
    if (window.listVideo[nb] && window.listVideo[nb].muted === false) {
      window.listVideo[nb].muted = true;
    }
  }

  handleUnMute(nb) {
    // youtube
    if (window.listVideo[nb] && typeof window.listVideo[nb].unMute !== this.config.undefined) {
      window.listVideo[nb].unMute();
      setTimeout(() => {
        window.listVideo[nb].setVolume(100);
      }, 10)
    }

   // vimeo
    if (window.listVideo[nb] && typeof window.listVideo[nb].setVolume === this.config.handleFunction) {
      window.listVideo[nb].setVolume(1);
    }

    if (window.listVideo[nb] && window.listVideo[nb].muted === true) {
      window.listVideo[nb].muted = false;
    }
  }

  handlePause(nb) {
    // youtube
    if (window.listVideo[nb] && typeof window.listVideo[nb].pauseVideo !== this.config.undefined) {
      window.listVideo[nb].pauseVideo();
    }
    if (window.listVideo[nb] && typeof window.listVideo[nb].pause === this.config.handleFunction) {
      window.listVideo[nb].pause();
    }
  }

  handlePlay(nb) {
    if (window.listVideo[nb] && typeof window.listVideo[nb].playVideo !== this.config.undefined) {
      window.listVideo[nb].playVideo();
      setTimeout(() => {
        window.listVideo[nb].playVideo();
      }, 50)
    }
    if (window.listVideo[nb] && typeof window.listVideo[nb].play === this.config.handleFunction) {
      setTimeout(() => {
        window.listVideo[nb].play();
      }, 500);
    }
  }
}